if (typeof window.Shopify === 'undefined') {
  window.Shopify = {};
}

if (typeof Shopify.formatMoney !== 'function') {
  Shopify.formatMoney = function (cents, format) {
    var moneyFormat = format || '{{amount}}';
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    cents = Math.round(parseFloat(cents));
    if (isNaN(cents)) {
      cents = 0;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? decimal + parts[1] : '';
      return dollarsAmount + centsAmount;
    }

    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var match = moneyFormat.match(placeholder);
    if (!match) {
      return formatWithDelimiters(cents, 2);
    }

    var formatted;
    switch (match[1]) {
      case 'amount':
        formatted = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        formatted = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        formatted = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        formatted = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        formatted = formatWithDelimiters(cents, 2, "'", '.');
        break;
      case 'amount_without_trailing_zeros':
        formatted = formatWithDelimiters(cents, 2);
        if (formatted.indexOf(',') !== -1) {
          formatted = formatted.replace(/,00$/, '');
        } else {
          formatted = formatted.replace(/\.00$/, '');
        }
        break;
      default:
        formatted = formatWithDelimiters(cents, 2);
    }

    return moneyFormat.replace(placeholder, formatted);
  };
}
